import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import aws_exports from './aws-exports';

import {Layout} from './Layout';
import { ThemeProvider } from '@aws-amplify/ui-react';
import { theme } from './theme';

Amplify.configure(aws_exports);



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Layout>
        <App />
      </Layout>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
